import { Breadcrumbs, Link } from "@mui/material";
import { useLocation } from "react-router-dom";

const BreadcrumbBillingManual = ({ isWarehouse }) => {
  const { pathname } = useLocation();

  return (
    <Breadcrumbs sx={{ color: "#1761FD", marginBottom: 2, fontSize: 12 }}>
      <Link
        href="/profile"
        underline="hover"
        color="#1761FD"
        sx={{ color: "#1761FD" }}
      >
        Homepage
      </Link>
      <Link
        color="#1761FD"
        underline="none"
        href={`${isWarehouse ? "/central-warehouse" : ""}/manual-billing`}
        sx={{ color: "#1761FD" }}
      >
        Manual Billing
      </Link>
      {["/manual-billing/po-list", "/manual-billing/create-billing/"].some(
        (link) => pathname.includes(link)
      ) ? (
        <Link
          underline="none"
          color="#1761FD"
          href={`${
            isWarehouse ? "/central-warehouse" : ""
          }/manual-billing/po-list`}
          sx={{ color: "#1761FD" }}
        >
          Buat Billing
        </Link>
      ) : null}
      {pathname.includes("/manual-billing/detail/") ? (
        <Link underline="none" color="#1761FD" sx={{ color: "#1761FD" }}>
          Detail Billing
        </Link>
      ) : null}
      {pathname.includes("/manual-billing/edit-draft/") ? (
        <Link underline="none" color="#1761FD" sx={{ color: "#1761FD" }}>
          Edit Draft Billing
        </Link>
      ) : null}
    </Breadcrumbs>
  );
};

export default BreadcrumbBillingManual;
